<template>

    <section
            class="features"
            v-bind:class="{ 'isScrolledIntoView' : isLoaded && isReflowed && isScrolledIntoView }"
    >

        <div
                class="features-inner"
                v-if="isLoaded"
        >

            <h2 class="heading" v-if="featuresHeading">
                {{ featuresHeading }}
            </h2>

            <div class="slick">
                <div v-for="post in posts.slice(0, featuresMaxItems)">
                    <div
                            class="item"
                            v-on:click="slickItemClickHandler(wpApi.stripBaseUrl(post['link']))"
                    >
                        <div class="aspect-ratio-box item-image">
                            <div class="aspect-ratio-box-inner">
                                <div class="diamond-box">
                                    <div class="diamond-box-inner">
                                        <img
                                                v-if="post['acf']['teaser_image_720_720']"
                                                v-bind:alt="post['acf']['teaser_image_alt_text']"
                                                v-bind:src="wpApi.stripHost(post['acf']['teaser_image_720_720'])"
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4
                                class="item-heading"
                                v-html="post['acf']['teaser_title']"
                        ></h4>
                        <p
                                class="item-text"
                                v-html="post['acf']['teaser_copy']"
                        ></p>
                        <p class="item-action">
                            <button class="btn btn-white-pink-black-white ani-btn-hover-scale-bounce">
                                mehr erfahren
                            </button>
                        </p>
                    </div>
                </div>
            </div>

        </div>

    </section>

</template>

<script>

    // console.log('Features');

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
    import cssUnitHelper from '../services/cssUnitHelper';
    import loader from '../services/loader';
    import scrollHelper from '../services/scrollHelper';
    import wpApi from '../services/wpApi';

    import Vue from 'vue';

    export default {
        mixins : [smoothReflow],
        created(){
            this.$root.events.$on('route-transition', ()=>{
                this.scrollHandler();
            });
            window.addEventListener('scroll', this.scrollHandler, { passive : true });
        },
        destroyed(){
            window.removeEventListener('scroll', this.scrollHandler);
            this.$el.removeEventListener('transitionend', this.transitionEndHandler);
            $(this.slickElement).off('afterChange', this.slickAfterChangeHandler());
            $(this.slickElement).off('beforeChange', this.slickBeforeChangeHandler());
        },
        mounted(){
            this.$el.addEventListener('transitionend', this.transitionEndHandler);
            this.$smoothReflow({
                transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
            });
            if (this.featuresForceLoading) {
                if (this.isLoaded === false) {
                    if (this.isLoading === false) {
                        this.isLoading = true;
                        loader.queue(this.load());
                    }
                }
            }
            this.scrollHandler();
            this.load();
        },
        components : {},
        data(){
            return {
                isLoaded : false,
                isLoading : false,
                isReflowed : false,
                isScrolledIntoView : false,
                posts : [],
                scrollViewOffsetTopPx : cssUnitHelper.remToPx(4),
                slickElement : null,
                slickIsSliding : false,
                slickOptions : {
                    arrows : false,
                    infinite : false,
                    responsive : [
                        {
                            breakpoint : 767,
                            settings : {
                                slidesToScroll : 1,
                                slidesToShow : 1,
                            },
                        },
                    ],
                    slidesToScroll : 1,
                    slidesToShow : 3,
                },
                wpApi,
            };
        },
        props : {
            'featuresExcludePostIds' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'featuresExcludePostPermalinks' : {
                default : ()=>{
                    return [];
                },
                type : Array,
            },
            'featuresFilterParams' : {
                default : {},
                type : Object,
            },
            'featuresForceLoading' : {
                default : false,
                type : Boolean,
            },
            'featuresHeading' : {
                default : '',
                type : String,
            },
            'featuresId' : {
                default : '',
                type : String,
            },
            'featuresMaxItems' : {
                default : 3,
                type : Number,
            },
        },
        methods : {
            load(){
                let url = wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/posts?';
                if (this.featuresFilterParams.posts) {
                    url += wpApi.getQueryStringForPostIds(this.featuresFilterParams.posts);
                } else {
                    // if (this.featuresFilterParams.primaryKeywords.length) {
                    //     if (typeof this.featuresFilterParams.primaryKeywords[0] === 'number') {
                    //         url += wpApi.getQueryStringForTaxonomyTagIds(this.featuresFilterParams.primaryKeywords, 'primary_keyword');
                    //     } else {
                    //         url += wpApi.getQueryStringForTaxonomyTags(this.featuresFilterParams.primaryKeywords, 'primary_keyword');
                    //     }
                    // }
                    if (this.featuresFilterParams.seriesKeywords.length) {
                        if (typeof this.featuresFilterParams.seriesKeywords[0] === 'number') {
                            url += wpApi.getQueryStringForTaxonomyTagIds(this.featuresFilterParams.seriesKeywords, 'series_keyword');
                        } else {
                            url += wpApi.getQueryStringForTaxonomyTags(this.featuresFilterParams.seriesKeywords, 'series_keyword');
                        }
                    }
                }
                return wpApi.http.get(url)
                    .then((response)=>{
                        console.log('response', response);
                        if (Array.isArray(response.data) === false || response.data.length === 0) {
                            return;
                        }
                        this.posts = response.data;
                        this.posts = this.posts.filter((post)=>post['acf']['visibility_published']);
                        this.isLoaded = true;
                        this.isLoading = false;
                        this.$root.events.$emit('loaded', this.featuresId);
                        if (this.featuresExcludePostPermalinks.length) {
                            this.featuresExcludePostPermalinks.forEach((permalink)=>{
                                this.posts = this.posts.filter((post)=>{
                                    if (post.link === wpApi.host + wpApi.baseUrl + '/' + permalink + '/') {
                                        return false;
                                    }
                                    return true;
                                });
                            });
                        }
                    })
                    .catch((error)=>{
                        console.log('error', error);
                    });
            },
            scrollHandler(){
                this.isScrolledIntoView = scrollHelper.isScrolledIntoView(
                    this.$el, this.scrollViewOffsetTopPx * cssMediaQueryHelper.watch.factor,
                );
                if (this.isScrolledIntoView === false) {
                    return;
                }
                // if (loader.isLoading()) {
                //     return;
                // }
                // if (this.isLoaded === false) {
                //     if (this.isLoading === false) {
                //         this.isLoading = true;
                //         loader.queue(this.load());
                //     }
                // }
                window.removeEventListener('scroll', this.scrollHandler);
            },
            slickAfterChangeHandler(){
                this.slickIsSliding = false;
            },
            slickBeforeChangeHandler(){
                this.slickIsSliding = true;
            },
            slickInit(){
                if (this.slickElement === null) {
                    this.slickElement = this.$el.querySelector('.slick');
                    $(this.slickElement).slick(this.slickOptions);
                    $(this.slickElement).on('afterChange', this.slickAfterChangeHandler);
                    $(this.slickElement).on('beforeChange', this.slickBeforeChangeHandler);
                }
            },
            slickItemClickHandler(route){
                if (this.slickIsSliding === false) {
                    this.$router.push(route);
                }
            },
            transitionEndHandler(event){
                if (this.isLoaded && event.target === this.$el) {
                    this.isReflowed = true;
                }
            },
        },
        watch : {
            isLoaded(value){
                if (value) {
                    Vue.nextTick(()=>{
                        this.slickInit();
                    });
                }
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .features {
        background-color: $color-nochvielvor-pink;
        overflow: hidden;
        will-change: height;
        margin-top: 1.5rem;
        @media screen and (min-width: 1200px) {
            margin-top: 1.5rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin-top: 1.5rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin-top: 1.5rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin-top: 1.5rem * $factor-2400;
        }
        &.isScrolledIntoView {
        }
        a {
            &,
            &:hover {
                text-decoration: none;
            }
        }
        .features-inner {
            padding: 2.5rem 1.5rem 3rem 1.5rem;
            @media screen and (min-width: 1200px) {
                padding: 2.5rem * $factor-1200 1.5rem * $factor-1200 3rem * $factor-1200 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 2.5rem * $factor-1440 1.5rem * $factor-1440 3rem * $factor-1440 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 2.5rem * $factor-1920 1.5rem * $factor-1920 3rem * $factor-1920 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 2.5rem * $factor-2400 1.5rem * $factor-2400 3rem * $factor-2400 1.5rem * $factor-2400;
            }
        }
        .heading {
            margin: 0 0 2rem 0;
            color: $color-nochvielvor-white;
            font-size: 2.25rem;
            font-weight: bold;
            text-transform: uppercase;
            @media screen and (min-width: 1200px) {
                margin: 0 0 2rem * $factor-1200 0;
                font-size: 2.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 2rem * $factor-1440 0;
                font-size: 2.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 2rem * $factor-1920 0;
                font-size: 2.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 2rem * $factor-2400 0;
                font-size: 2.25rem * $factor-2400;
            }
        }
        .item {
            display: flex;
            flex-direction: column;
            height: 100%;
            color: $color-nochvielvor-white;
            cursor: pointer;
            outline: none;
            font-size: 0.75rem;
            text-align: center;
            padding: 0 1.5rem;
            @media screen and (max-width: 767px) {
            }
            @media screen and (min-width: 1200px) {
                padding: 0 1.5rem * $factor-1200;
                font-size: 0.75rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 0 1.5rem * $factor-1440;
                font-size: 0.75rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 0 1.5rem * $factor-1920;
                font-size: 0.75rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 0 1.5rem * $factor-2400;
                font-size: 0.75rem * $factor-2400;
            }
            .item-action {
                margin: auto 0 0 0;
            }
            .item-text {
                margin: 1rem 0;
                color: $color-nochvielvor-white;
                font-size: 0.75rem;
                @media screen and (min-width: 1200px) {
                    margin: 1rem * $factor-1200 0;
                    font-size: 0.75rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin: 1rem * $factor-1440 0;
                    font-size: 0.75rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin: 1rem * $factor-1920 0;
                    font-size: 0.75rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin: 1rem * $factor-2400 0;
                    font-size: 0.75rem * $factor-2400;
                }
            }
            .item-heading {
                margin: 1rem 0 0 0;
                color: $color-nochvielvor-white;
                font-size: 1.125rem;
                font-weight: bold;
                text-transform: uppercase;
                @media screen and (min-width: 1200px) {
                    margin: 1rem * $factor-1200 0 0 0;
                    font-size: 1.125rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin: 1rem * $factor-1440 0 0 0;
                    font-size: 1.125rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin: 1rem * $factor-1920 0 0 0;
                    font-size: 1.125rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin: 1rem * $factor-2400 0 0 0;
                    font-size: 1.125rem * $factor-2400;
                }
            }
            .item-image {
                width: calc(100% - 1.5rem);
                margin: 0 auto;
                transform-origin: 50% 75%;
                transition: transform 1200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                will-change: transform;
                .diamond-box-inner {
                    transition: transform 1200ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
                    will-change: transform;
                }
                @media screen and (min-width: 1200px) {
                    width: calc(100% - 1.5rem * #{$factor-1200});
                }
                @media screen and (min-width: 1440px) {
                    width: calc(100% - 1.5rem * #{$factor-1440});
                }
                @media screen and (min-width: 1920px) {
                    width: calc(100% - 1.5rem * #{$factor-1920});
                }
                @media screen and (min-width: 2400px) {
                    width: calc(100% - 1.5rem * #{$factor-2400});
                }
                &:hover {
                    transform: scale(1.1);
                    .diamond-box-inner {
                        transform: translate3d(-50%, -50%, 0) rotate(45deg) scale(1.1);
                    }
                }
            }
        }
        .slick {
            margin: 0 -1.5rem;
            @media screen and (min-width: 1200px) {
                margin: 0 -1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 -1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 -1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 -1.5rem * $factor-2400;
            }
            a {
                outline: none;
            }
            .slick-list {
                overflow: visible;
                .slick-track {
                    display: flex;
                    will-change: transform;
                    .slick-slide {
                        height: inherit;
                        > div {
                            height: 100%;
                            > div {
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// public/js/components/Features.vue